<template>
  <div>
    <el-dialog
      class="dialog-container"
      :visible.sync="addDialog"
      :title.sync="title"
      @closed="handleCancel"
      @opened="beforeOpen"
      width="60%"
      :append-to-body="true"
    >
      <el-form
        ref="addFrom"
        :model="addFrom"
        :rules="addRules"
        label-width="120px"
        :validate-on-rule-change="false"
      >
        <el-collapse
          v-model="activeNames"
          @change="handleChange"
        >
          <el-collapse-item
            title="会员类型-类别配置"
            name="1"
          >
            <el-form-item
              prop="type"
              label="会员类别"
            >
              <el-radio
                @change="fixValidate('type')"
                v-for="item in type"
                :key="item.value"
                :disabled="title === '编辑会员类型'"
                v-model="addFrom.type"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-form-item>
            <el-form-item
              label="会员等级"
              prop="level"
            >
              <el-select
                @change="fixValidate('level')"
                v-model="addFrom.level"
                placeholder="请选择会员等级"
              >
                <el-option
                  v-for="item in level"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="权重等级"
              prop="weightLevel"
            >
              <div>
                <el-input
                  v-model="addFrom.weightLevel"
                  placeholder="正整数输入"
                  style="width: 210px; margin-right: 10px"
                ></el-input>
                <el-tooltip
                  content="数字越大权重越高，同等级下，优先消耗权重高的类型权益"
                  placement="right"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
            </el-form-item>

            <el-form-item label="售卖状态" prop="sellStatus">
              <el-radio-group v-model="addFrom.sellStatus" @change="changeSellStatus">
                <el-radio :label="1">在售</el-radio>
                <el-radio :label="0">停售</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="用户身份"
              prop="memberIdentity"
            >
              <el-radio-group
                :disabled="title === '编辑会员类型'"
                v-model="addFrom.memberIdentity"
              >
                <el-popover
                  v-for="item in memberIdentity"
                  width="400"
                  :key="item.value"
                  placement="top-start"
                  trigger="hover"
                  :content="item.content"
                >
                  <el-radio
                    @change="fixValidate('memberIdentity')"
                    style="margin-right: 20px"
                    slot="reference"
                    :label="item.value"
                  >{{ item.label }}</el-radio>
                </el-popover>
              </el-radio-group>
            </el-form-item>

          </el-collapse-item>
          <el-collapse-item
            title="会员类型-基础配置"
            name="2"
          >
            <el-form-item
              label="会员类型名称"
              prop="name"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 10 }"
                width="40%"
                maxlength="99"
                show-word-limit
                v-model="addFrom.name"
                placeholder="请输入会员类型名称"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="会员图标"
              prop="icon"
            >
              <div style="
                  display: flex;
                  justify-items: center;
                  align-items: center;
                ">
                <el-image
                  v-if="addFrom.icon"
                  style="width: 100px; height: 100px; margin-right: 10px"
                  fit="scale-down"
                  :src="addFrom.icon"
                >
                </el-image>
                <el-upload
                  class="upload-demo"
                  :before-upload="checkUpload"
                  :http-request="upload"
                  listType="picture-img"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :show-file-list="false"
                >
                  <el-button size="small">上传会员图标</el-button>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item
              label="类型描述"
              prop="description"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 99 }"
                width="40%"
                maxlength="999"
                show-word-limit
                v-model="addFrom.description"
                placeholder="请输入会员类型描述"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="addFrom.memberIdentity === '2'"
              label="刊例价格"
              prop="publishPrice"
            >
              <el-popover
                width="400"
                placement="top-start"
                trigger="hover"
                content="会员升级时取自此字段的价格数值，按照单日的刊例价格来计算"
              >
                <div
                  slot="reference"
                  style="display: flex"
                >
                  <el-input
                    style="width: 30%; margin-right: 10px"
                    v-model="addFrom.publishPrice"
                    placeholder="请输入价格"
                  ></el-input>元/日
                </div>
              </el-popover>
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item
            title="会员类型-权益配置"
            name="3"
          >
            <el-form-item
              label="客户端类型"
              prop="clientTypes"
            >
              <el-popover
                width="400"
                placement="top-start"
                trigger="hover"
                content="配置逻辑是给哪些客户端配置哪些会员权益，可针对不同的客户端配置不同的权益"
              >
                <el-cascader-panel
                  slot="reference"
                  v-model="clientSelect"
                  :options="clientSelectList"
                  style="width: 400px"
                  :props="{ multiple: true }"
                  ref="clientTypesSelect"
                  @change="selectChange"
                />
              </el-popover>
            </el-form-item>
            <el-form-item
              label="权益项集"
              prop="memberTypeRightsItems"
            >
              <el-popover
                width="400"
                placement="top-start"
                trigger="hover"
                content="代表所有选择的权益（不区分端）的集合
              若在权益管理处配置某项权益携带限制参数，则会在下方显示参数配置"
              >
                <span slot="reference">
                  <el-tag
                    style="margin-right: 10px"
                    :key="item.label"
                    v-for="item in memberTypeRightsItems"
                    closable
                    :disable-transitions="false"
                    @close="handleCloseTag(item)"
                  >
                    {{ item.label }}
                  </el-tag>
                </span>
              </el-popover>
            </el-form-item>
            <div
              class="memberType_newMemberTypeRightsItems_container"
              v-for="(item, index) in addFrom.newMemberTypeRightsItems"
              :key="index"
              style="padding-left: 50px; background-color: #eff0f3;"
            >
              <div
                class="memberType_newMemberTypeRightsItems_box"
                v-if="item.limitParams && filterLimitParams(item.value)"
                style="display: flex; margin-bottom: 10px;"
              >
                <div
                  class="memberType_newMemberTypeRightsItems_label"
                  v-if="item.limitParams.length > 0 && item.limitParams[0].code"
                  style="width: 15%; padding: 20px;"
                >
                  {{item.label}}
                </div>
                <div
                  class="memberType_newMemberTypeRightsItems_box_content"
                  style="flex: 1;"
                >
                  <el-form-item
                    class="memberType_newMemberTypeRightsItems"
                    v-for="(ele, childIndex) in item.limitParams"
                    :key="ele.code"
                    :prop="`newMemberTypeRightsItems.${index}.limitParams.${childIndex}.inputValue`"
                  >
                    <div
                      v-if="ele.code"
                      style="
                        display: flex;
                        justify-items: center;
                        align-items: center;
                        justify-content: flex-start;
                        margin-left: -65px;
                        padding: 10px 0 20px 0;
                      "
                    >
                      <span
                        v-if="ele.code"
                        style="margin-left: 20px;width: 25%; color: #6c6c6c;"
                      >
                        {{ ele.desc }}</span>
                      <el-input
                        v-if="ele.code"
                        v-model="ele.inputValue"
                        :placeholder="ele.remark"
                        style="width: 50%"
                      ></el-input>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </div>
            <el-form-item
              label="类型状态"
              prop="state"
            >
              <el-radio-group v-model="addFrom.state">
                <el-radio label="1">启用</el-radio>
                <el-radio label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="备注"
              prop="remark"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 10000 }"
                width="40%"
                maxlength="9999"
                show-word-limit
                v-model="addFrom.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >保 存</el-button>
      </span>
      <el-dialog
        :title="`在售的类型`"
        :visible.sync="sellStatusConfirmVisible"
        width="30%"
        :append-to-body="true"
        :before-close="handleSellStatusCancel"
      >
        <div class="sellVipTypeContainer">
          <div>当前会员类别下的会员等级在售的会员类型有：</div>
          <template v-if="addFrom.sellVipType && addFrom.sellVipType.length > 0">
            <div v-for="item in addFrom.sellVipType" :key="item.value" class="sellVipType">
              ({{ item.value }}) {{ item.label }}
            </div>
          </template>
          <template v-else>
            <div class="noSellVipType">当前会员类别下的会员等级暂无在售的会员类型</div>
          </template>
        </div>
        <div class="sellVipTypeContainer">
          操作“在售”后，需注意：<br>
          1、该配置审批生效后，同等级其余会员类型状态<span style="color: #ff4040;">自动变更为“停售”</span><br>
          2、在售状态不影响商品 SKU 是否可购买，运营需配合手动<span style="color: #296df3;">下掉对应的停售类型下的会员商品</span> 及 <span style="color: #296df3;">更改“支付页”配置</span><br>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align: center;"
        >
          <el-button type="primary" @click="handleSellStatusConfirm">确认，更改为“在售”状态</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import Message from '@/components/Message';
import {
  addMemberTypeLocal,
  getMemberRightLocalList,
  getMemberRightLocalLimitParams,
  getSmallScene,
  getBigScene,
  getSdkScene,
  getMemberType,
  getUserIdentity,
  editMemberTypeLocal,
  getMemberTypeLocalListBySellStatus
} from '@/api/memberNew/memberType';
import axios from 'axios';
export default {
  name: 'WebSassMemberTypeAddDialog',
  props: {
    /** 对话框的显隐 */
    addDialog: {
      type: Boolean,
      default: false
    },
    /** 添加或者编辑的表单 */
    addFrom: {
      type: Object,
      default() {
        return {
          name: '',
          level: '',
          weightLevel: '',
          applyScene: '1', // 已经没有该应用场景业务，但是接口未修改，保留字段
          icon: '',
          sceneFlag: '1', // 已经没有该展示场景业务，但是接口未修改，保留字段
          clientTypes: [],
          memberTypeRightsItems: [],
          newMemberTypeRightsItems: [],
          description: '',
          publishPrice: '',
          memberIdentity: '',
          state: '',
          remark: '',
          sellStatus: 0,
          sellVipType: []
        };
      }
    },
    /** 编辑的回填数据 */
    editData: {
      type: Object,
      default() {
        return {};
      }
    },
    /** 选中的客户端类型 */
    clientSelect: {
      type: Array,
      default: () => {
        return [];
      }
    },
    TableClientSelect: {
      type: Array,
      default: () => {
        return [];
      }
    },
    /** 对话框标题 */
    title: {
      type: String,
      default: '新增会员权益'
    }
  },
  data() {
    return {
      /** 售卖状态确认对话框的显隐 */
      sellStatusConfirmVisible: false,
      /** 临时会员权益项存储 */
      tempRightItems: [],
      memberTypeRightsItems: [],
      /** 限制参数输入的值 */
      limitParamsInputValue: '',
      /** 用户身份 */
      memberIdentity: [],
      /** 会员类别 */
      type: [],
      /** 展示场景 */
      memberRightLocalScene: '',
      /** 折叠面板 */
      activeNames: ['1'],
      /** 全局的每个权益对应的限制参数 */
      memberRightLocalLimitParams: [],
      /** 客户端类型下拉列表 */
      clientSelectList: [],
      /** 会员等级 */
      level: [
        {
          label: '1级',
          value: 1
        },
        {
          label: '2级',
          value: 2
        },
        {
          label: '3级',
          value: 3
        },
        {
          label: '4级',
          value: 4
        },
        {
          label: '5级',
          value: 5
        }
      ]
    };
  },
  computed: {
    /** 表单验证规则 */
    addRules() {
      const rules = {
        type: [
          {
            required: true,
            message: '请选择会员类型',
            trigger: 'change'
          }
        ],
        level: [
          {
            required: true,
            message: '请选择会员等级',
            trigger: 'change'
          }
        ],
        weightLevel: [
          {
            required: true,
            message: '请输入权重等级',
            trigger: 'blur'
          },
          {
            pattern: /^[1-9]\d*$/,
            message: '权重等级必须为正整数',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请选择会员名称',
            trigger: 'change'
          }
        ],
        publishPrice: [
          {
            required: true,
            message: '请输入会员价格',
            trigger: 'blur'
          },
          /** 最多五位数，保留两位小数 */
          {
            pattern: /^(([1-9]\d{0,4})|0)(\.\d{1,2})?$/,
            message: '最多五位数，保留两位小数',
            trigger: 'blur'
          }
        ],
        memberTypeRightsItems: [
          {
            required: true,
            message: '请选择权益项集',
            trigger: 'change'
          }
        ],
        clientTypes: [
          {
            required: true,
            message: '请选择客户端类型',
            trigger: ['change', 'blur']
          }
        ],
        memberIdentity: [
          {
            required: true,
            message: '请选择用户身份',
            trigger: 'change'
          }
        ],
        state: [
          {
            required: true,
            message: '请选择类型状态',
            trigger: 'change'
          }
        ],
        sellStatus: [
          {
            required: true,
            message: '请选择售卖状态',
            trigger: 'change'
          }
        ],
        sceneFlag: [
          {
            required: true,
            message: '请选择展示场景',
            trigger: ['change', 'blur']
          }
        ],
        newMemberTypeRightsItems: {}
      };
      (this.addFrom.newMemberTypeRightsItems || []).forEach((data, i) => {
        const limitParams = data.limitParams.reduce((obj, _, i) => {
          obj[i] = {
            inputValue: [
              {
                required: false,
                trigger: 'blur'
              },
              { validator: this.validateNonNegative, trigger: 'blur' }
            ]
          };

          return obj;
        }, {});
        rules.newMemberTypeRightsItems[i] = { limitParams };
      });

      console.log('rules', rules);
      return rules;
    }
  },
  watch: {
    TableClientSelect: {
      handler(val) {
        if (val.length) {
          this.clientSelect = [...val];
          /** 为了出现权益项集合 */
          this.selectChange();
          /** 回填正确的限制参数 */
          // this.$nextTick(() => {
          console.log('val', val);
          console.log('详情传过来的数据', this.addFrom);
          console.log('---', this.memberTypeRightsItems);

          this.$nextTick(() => {
            // 遍历 this.addFrom.limitParamVals 数组
            for (const addFromItem of this.addFrom.limitParamVals) {
              // 遍历 this.memberTypeRightsItems 数组
              for (const memberTypeRightsItem of this.memberTypeRightsItems) {
                // 检查 value 和 rightsCode 是否匹配
                if (memberTypeRightsItem.value === addFromItem.rightsCode) {
                  // 遍历 memberTypeRightsItem.limitParams 数组
                  for (const limitParam of memberTypeRightsItem.limitParams) {
                    // 查找匹配的 limitParamCode
                    const addFromLimitParam = addFromItem.limitParams.find((item) => item.limitParamCode === limitParam.code);
                    // 如果找到匹配的 limitParamCode，则将 limitParamVal 赋值给 inputValue
                    if (addFromLimitParam) {
                      limitParam.inputValue = addFromLimitParam.limitParamVal;
                    }
                  }
                }
              }
            }
          });
          console.log('处理之后详情传过来的数据', this.addFrom);
          console.log('处理之后权益项', this.memberTypeRightsItems);

          /** 用set防止丢失响应 */
          this.$set(this.addFrom, 'newMemberTypeRightsItems', JSON.parse(JSON.stringify(this.memberTypeRightsItems)));
          // });
        }
      },
      immediate: true
    },
    'addFrom.type': {
      handler(val) {
        val && this.selectType(val);
      },
      immediate: true
    },
    memberTypeRightsItems: {
      handler(val) {
        console.log('权益项', val);
      }
    }
  },
  created() {
    this.getMemberRightLocalList();
    /** 获取字典里的会员类别 */
    this.getMemberType();
    /** 获取字典里的用户身份 */
    this.getUserIdentity();
  },
  mounted() {},

  methods: {
    validateNonNegative(rule, value, callback) {
      console.log('validateNonNegative', value);
      if ((value == 0 && value) || (value < 0 && value)) {
        callback(new Error('不能填写0或负数'));
      } else {
        callback();
      }
    },
    /** 售卖状态改变 */
    async changeSellStatus(sellStatus) {
      if (sellStatus === 1) {
        if (this.addFrom.level === '' || this.addFrom.type === '') {
          this.addFrom.sellStatus = 0;
          Message.error('请选择会员等级和会员类别');
          return;
        }
          
        
        try {
          // 查询在售的类型
          const { data } = await getMemberTypeLocalListBySellStatus({
            level: this.addFrom.level,
            memberTypeId: this.title === '编辑会员类型' ? this.addFrom.id : '',
            type: this.addFrom.type
          });
          
          console.log('在售的类型', data);

          if (data.code !== 200) {
            return;
          }

          this.addFrom.sellVipType = data.data.map(item => ({
            value: item.id,
            label: item.name
          }));

          this.sellStatusConfirmVisible = true;  
        } catch (error) {
          Message.error(error.message);
        } 
      }
    },
    /** 取消更改售卖状态 */
    handleSellStatusCancel() {
      this.sellStatusConfirmVisible = false;
      this.addFrom.sellStatus = 0;
    },
    /** 确认更改售卖状态 */
    handleSellStatusConfirm() {
      this.sellStatusConfirmVisible = false;
    },
    /** 对话框关闭按钮 */
    handleCancel() {
      /** 清理数据 */
      // this.$refs.addFrom.clearValidate();
      /**  */
      this.$refs.addFrom.clearValidate('clientTypes');
      this.$refs.addFrom.clearValidate('memberTypeRightsItems');
      this.$refs.addFrom.resetFields();
      /**  */
      this.addFrom = {
        name: '',
        level: '',
        weightLevel: '',
        icon: '',
        sceneFlag: '1',
        applyScene: '1',
        clientTypes: [],
        memberTypeRightsItems: [],
        description: '',
        publishPrice: '',
        memberIdentity: '',
        state: '',
        remark: '',
        sellStatus: 0,
        newMemberTypeRightsItems: [],
        sellVipType: []
      };
      this.clientSelect = [];
      this.memberTypeRightsItems = [];
      this.sellStatusConfirmVisible = false;
      this.$refs.addFrom.clearValidate();
      this.$emit('updateData');
      this.$emit('update:addDialog', false);
    },
    /** 选中客户端类型 */
    async selectChange() {
      console.log('this.clientSelect', this.clientSelect);
      this.$nextTick(() => {
        const res = this.$refs.clientTypesSelect.getCheckedNodes(true);
        console.log('select:', res);
        /** 赋值只是为了通过表单的验证 */
        this.addFrom.clientTypes = this.clientSelect;

        if (res.length === 0) {
          this.memberTypeRightsItems = [];
          this.addFrom.newMemberTypeRightsItems = [];
          this.addFrom.memberTypeRightsItems = [];

          this.$refs.addFrom.validateField('clientTypes');
          this.$refs.addFrom.validateField('memberTypeRightsItems');
          return;
        }

        /** 
         * 1. 暂存当前已有的权益项数据，用于回填用户已输入的值 
         * 使用 Map 提高查找效率，Key 为权益的 value (code)
         */
        const prevItemsMap = new Map();
        if (this.memberTypeRightsItems && this.memberTypeRightsItems.length > 0) {
          this.memberTypeRightsItems.forEach(item => {
            if (item.value) {
              prevItemsMap.set(item.value, item);
            }
          });
        }

        /** 
         * 2. 客户端类型权益集取并集（去重） 
         * 使用 Set 记录已存在的 value，过滤掉重复项，提高可读性和性能
         */
        const seenValues = new Set();
        const uniqueArr = res.filter((item) => {
          const value = item.data.value;
          if (seenValues.has(value)) {
            return false;
          }
          seenValues.add(value);
          return true;
        });

        /** 
         * 3. 构建新的权益项列表 
         * 在一次遍历中完成数据查找和构建
         */
        this.memberTypeRightsItems = uniqueArr.map((node) => {
          const rightsValue = node.data.value;

          // 获取权益对应的限制参数定义 (level2Dict)
          const rightsDef = this.memberRightLocalLimitParams.find(item => item.code === rightsValue);
          const level2Dict = (rightsDef && rightsDef.level2Dict) ? rightsDef.level2Dict : [];

          // 获取之前保存的该权益的用户输入数据
          const prevItem = prevItemsMap.get(rightsValue);
          const prevLimitParams = prevItem ? prevItem.limitParams : [];

          // 映射限制参数，回填用户输入
          const limitParams = level2Dict.map((paramDef, index) => {
            let inputValue = '';
            
            if (prevLimitParams.length > 0) {
              // 策略1: 优先尝试通过 code 匹配参数         
              const matchByCode = prevLimitParams.find(p => p.code === paramDef.code);
              
              if (matchByCode) {
                inputValue = String(matchByCode.inputValue || '');
              } else if (prevLimitParams[index]) {
                // 策略2: 如果没有 code 或未匹配到，尝试按索引顺序兜底回填
                // 注意：旧逻辑是盲目取 [0]，这里按索引取更合理，或者至少保留了之前“有值就填”的意图
                inputValue = String(prevLimitParams[index].inputValue || '');
              }
            }

            return {
              ...paramDef,
              inputValue
            };
          });

          return {
            label: node.data.label,
            value: node.data.value,
            remark: node.data.remark,
            path: node.path,
            limitParams: limitParams
          };
        });

        // 记录日志
        console.log('选中出现的会员权益标签', this.memberTypeRightsItems);

        // 同步到 addFrom 数据
        this.addFrom.newMemberTypeRightsItems = [...this.memberTypeRightsItems];
        this.addFrom.memberTypeRightsItems = res;

        /** 进行表单验证 */
        this.$refs.addFrom.validateField('clientTypes');
        this.$refs.addFrom.validateField('memberTypeRightsItems');
      });
    },
    /** 删除权益集标签 */
    handleCloseTag(item) {
      console.log('删除权益集标签的item', item);
      console.log('this.memberTypeRightsItems', this.memberTypeRightsItems);
      console.log('this.clientSelect', this.clientSelect);
      this.memberTypeRightsItems = this.memberTypeRightsItems.filter((v) => v !== item);
      this.addFrom.newMemberTypeRightsItems = [...this.memberTypeRightsItems];
      this.clientSelect = this.clientSelect.filter((v) => v.indexOf([...item.path].pop()) === -1);
      this.addFrom.clientTypes = [...this.clientSelect];
      console.log(' this.clientSelec', this.clientSelect);
      console.log('this.memberTypeRightsItems', this.memberTypeRightsItems);

      this.addFrom.memberTypeRightsItems = this.memberTypeRightsItems;

      /** 进行表单验证 */
      this.$refs.addFrom.validateField('clientTypes');
      this.$refs.addFrom.validateField('memberTypeRightsItems');
    },
    /** 确定添加的事件 */
    handleConfirm() {
      // /** 进行表单验证 */
      this.$refs.addFrom.validateField('clientTypes');
      this.$refs.addFrom.validateField('memberTypeRightsItems');
      console.log('this.addFrom', this.addFrom);
      console.log('this.clientSelect', this.clientSelect);
      console.log('this.memberTypeRightsItems', this.memberTypeRightsItems);
      /** 验证表单是否通过 */
      this.$refs.addFrom.validate(async (valid) => {
        if (valid) {
          /** 判断是新增还是编辑 */
          if (this.title === '编辑会员类型') {
            console.log('是编辑');

            console.log('选择的客户端', this.clientSelect);
            console.log('选中的会员权益标签', this.memberTypeRightsItems);
            /** 修正传递给接口的数据 */
            const result = this.clientSelect.reduce((arr, [clientType, rightsCode]) => {
              // 在结果数组中查找是否存在对应的rightCode对象
              const existingItem = arr.find((item) => item.rightsCode === rightsCode);

              if (existingItem) {
                // 如果存在，将当前clientType添加到对应的clientTypes字段中
                existingItem.clientTypes += `,${clientType}`;
              } else {
                // 如果不存在，创建新的对象，并初始化clientTypes字段
                arr.push({ rightsCode, clientTypes: clientType });
              }

              return arr;
            }, []);

            /** 拼接limitParamVals属性 */
            this.addFrom.memberTypeRightsItems = result.map((item) => {
              const limitParams = this.memberTypeRightsItems.filter((v) => v.value === item.rightsCode)[0].limitParams;

              console.log(this.memberTypeRightsItems.filter((v) => v.value === item.rightsCode)[0].limitParams);
              let limitParamVals = '';
              if (limitParams.some((v) => v.code !== '')) {
                limitParamVals = JSON.stringify(
                  limitParams.map((v) => ({
                    limitParamCode: v.code,
                    limitParamVal: v.inputValue ? Number(Number(v.inputValue)) : -1,
                    limitParamName: v.desc
                  }))
                );
              }
              return {
                ...item,
                limitParamVals
              };
            });
            /** 从addFrom删除client属性 */
            const addParams = { ...this.addFrom };         
            addParams.publishPrice = Number(Number(addParams.publishPrice).toFixed(2));
            delete addParams.clientTypes;
            /** 从addFrom删除newMemberTypeRightsItems */
            delete addParams.newMemberTypeRightsItems;
            /** 拼上编辑需要的id */
            console.log('addForm', addParams);

            addParams.weight = Number(addParams.weightLevel);
            addParams.saleStatus = Number(addParams.sellStatus);
            /** 调用接口 */
            const res = await editMemberTypeLocal(addParams);
            console.log('编辑接口的响应', res);
            /** 如果成功提示用户 */
            if (res.data.code === 200) {
              Message.success('编辑成功');

              /** 关闭对话框 */
              this.handleCancel();
            } else {
              Message.error(res.data.msg);
            }
          } else {
            /** 是新增 */
            console.log('选择的客户端', this.clientSelect);
            console.log('选中的会员权益标签', this.memberTypeRightsItems);
            /** 修正传递给接口的数据 */
            const result = this.clientSelect.reduce((arr, [clientType, rightsCode]) => {
              // 在结果数组中查找是否存在对应的rightCode对象
              const existingItem = arr.find((item) => item.rightsCode === rightsCode);

              if (existingItem) {
                // 如果存在，将当前clientType添加到对应的clientTypes字段中
                existingItem.clientTypes += `,${clientType}`;
              } else {
                // 如果不存在，创建新的对象，并初始化clientTypes字段
                arr.push({ rightsCode, clientTypes: clientType });
              }

              return arr;
            }, []);
            /** 拼接limitParamVals属性 */
            this.addFrom.memberTypeRightsItems = result.map((item) => {
              const limitParams = this.memberTypeRightsItems.filter((v) => v.value === item.rightsCode)[0].limitParams;

              let limitParamVals = '';
              if (limitParams.some((v) => v.code !== '')) {
                limitParamVals = JSON.stringify(
                  limitParams.map((v) => ({
                    limitParamCode: v.code,
                    limitParamVal: v.inputValue ? Number(Number(v.inputValue)) : -1,
                    limitParamName: v.desc
                  }))
                );
              }

              return {
                ...item,
                limitParamVals
              };
            });
            /** 从addFrom删除client属性 */
            const addParams = { ...this.addFrom };
            addParams.publishPrice = Number(Number(addParams.publishPrice).toFixed(2));
            delete addParams.clientTypes;
            addParams.weight = Number(addParams.weightLevel);
            addParams.saleStatus = Number(addParams.sellStatus);
            /** 从addFrom删除newMemberTypeRightsItems */
            delete addParams.newMemberTypeRightsItems;
            console.log('addForm', addParams);
            /** 调用接口 */
            const res = await addMemberTypeLocal(addParams);
            console.log('新增接口的响应', res);
            /** 如果成功提示用户 */
            if (res.data.code === 200) {
              Message.success('新增成功');

              /** 关闭对话框 */
              this.handleCancel();
            } else {
              Message.error(res.data.msg);
            }
          }
        } else {
          Message.error('请检查表单是否填写完整');
          return false;
        }
      });
    },
    /** 对话框打开之前的事件 */
    beforeOpen() {
      /** 清除验证规则 */

      this.$refs.addFrom.clearValidate();

      console.log('对话框打开之前的事件', this.clientSelect);
    },
    /** 上传图片校验 */
    checkUpload(file) {
      console.log(file);
      // 判断类型
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        Message.error('只能上传jpg/png格式的图片');
        return false;
      }
      // 判断大小
      if (file.size > 1024 * 1024 * 5) {
        Message.error('图片大小不能超过5M');
        return false;
      }
    },
    /** 上传图片的方法 */
    async upload(params) {
      const file = params.file;
      let formData = new FormData();
      formData.append('file', file);
      /** 正在上传图片 */
      // this.addFrom.icon = 'ing'
      try {
        const { data } = await axios.post('/lebo-resource/oss/endpoint/put-file?code=lebotob', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        const result = data.data;
        console.log('上传会员图标的响应', result);
        if (data.code === 200) {
          Message.success('上传成功');
        }
        /** 赋值会员图标 */
        this.addFrom.icon = result.link;
        /** 强刷新数据 */
        this.$forceUpdate();
      } catch (error) {
        throw new Error(error);
      }
    },
    /** 选择会员类别触发更新展示场景事件 */
    selectType(item) {
      console.log('选择会员类别触发更新展示场景事件', item);
      /** 根据不同的类别 赋值不同的展示场景 */
      if (item === '1') {
        this.getSmallScene();
      } else if (item === '2') {
        this.getBigScene();
      } else if (item === '3') {
        this.getSdkScene();
      }
    },
    /** 触发表单验证事件 */
    fixValidate(fields) {
      this.$refs.addFrom.validateField(fields);
    },
    //^ ^--------------//------------------获取初始数据方法-------------^ ^
    /** 获取客户端-权益项二级列表 */
    async getMemberRightLocalList() {
      const { data } = await getMemberRightLocalList();
      console.log('获取客户端-权益项二级列表', data);
      /** 把这个列表变成树形的 */
      const treeList = data.data.map((item) => {
        return {
          value: item.code,
          label: item.desc,
          remark: item.remark,
          children: item.level2Dict.map((childItem) => {
            return {
              value: childItem.code,
              label: childItem.desc,
              remark: childItem.remark
            };
          })
        };
      });
      console.log('treeList', treeList);
      this.clientSelectList = treeList;
      const { data: res } = await getMemberRightLocalLimitParams();
      console.log('权益项-限制参数字典', res.data);
      /** 把每个权益对应的限制参数作为全局数据使用 */
      this.memberRightLocalLimitParams = res.data;
    },

    /** 获取字典里的小屏会员展示场景 */
    async getSmallScene() {
      const { data } = await getSmallScene();
      /** 处理数据 */
      this.memberRightLocalScene = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue
        };
      });
      console.log('获取字典小屏会员展示场景', this.memberRightLocalScene);
    },
    /** 获取字典里的大屏会员展示场景 */
    async getBigScene() {
      const { data } = await getBigScene();
      /** 处理数据 */
      this.memberRightLocalScene = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue
        };
      });
      console.log('获取字典里的大屏会员展示场景', this.memberRightLocalScene);
    },
    /** 获取字典里的SDK会员展示场景 */
    async getSdkScene() {
      const { data } = await getSdkScene();
      /** 处理数据 */
      this.memberRightLocalScene = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue
        };
      });
      console.log('获取字典里的SDK会员展示场景', this.memberRightLocalScene);
    },
    /** 获取字典里的会员类型 */
    async getMemberType() {
      const { data } = await getMemberType();
      /** 处理数据 */
      this.type = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue
        };
      });

      console.log('获取字典里的会员类型', this.type);
    },
    /** 获取字典里的用户身份 */
    async getUserIdentity() {
      const { data } = await getUserIdentity();
      /** 处理数据 */
      this.memberIdentity = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue,
          content:
            item.dictValue === '登录用户'
              ? '选择登录用户，代表该会员类型是给登录用户下发的，所包含的免费权益下发给未购买会员的用户。'
              : '选择付费用户，代表该会员类型是给已购买会员的用户下发的，所包含的权益下发给已购买会员的用户。'
        };
      });
      console.log('获取字典里的用户身份', this.memberIdentity);
    },
    filterLimitParams(limitParamsVals) {
      // 手动过滤以下权益参数，不显示
      // - 切换云镜镜像清晰度
      // - 切换局域网镜像清晰度
      // - 倍速播放
      // - 免收端广告权益
      // - 免发端开屏
      // - 超级连接
      const hideLimitParamsCode = [
        'wan_mirror_switch_resolution',
        'receiver_cast_free_ad',
        'play_speed',
        'lan_mirror_switch_resolution',
        'super_connect',
        'sender_open_sceen_free_ad'
      ];

      return !hideLimitParamsCode.includes(limitParamsVals);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-container {
  /deep/ .el-textarea__inner {
    padding-right: 55px !important;
    max-height: 100px;
  }
}
/deep/ .memberType_newMemberTypeRightsItems {
  margin-bottom: 0 !important;
  .el-form-item__content {
    margin-left: 50px !important;
  }
  .el-form-item__error {
    position: absolute;
    left: 26%;
  }
  .el-form-item__error {
    top: 70%;
  }
}

.sellVipTypeContainer {
  margin-bottom: 10px;
  line-height: 25px;
  color: #000;
  .sellVipType {
    padding-left: 10px;
    color: #ff4040;
  }
  .noSellVipType {
    color: #999;
  }
}
</style>
